(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      // "always" = siempre visible (incluye el logo reducido).
      // "on-scroll-up" = se oculta al bajar y vuelve al subir.
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.setHeaderHeight();
      var headerMql = window.matchMedia('(max-width: 990px)');
      var headerMqlHandler = this.setHeaderHeight.bind(this);
      if (typeof headerMql.addEventListener === 'function') {
        headerMql.addEventListener('change', headerMqlHandler);
      } else if (typeof headerMql.addListener === 'function') {
        headerMql.addListener(headerMqlHandler);
      }
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
      this.initHoverMenus();
      this.initDropdownPositioning();
    }
    initDropdownPositioning() {
      const adjustDropdownPosition = () => {
        const dropdowns = document.querySelectorAll('.header__submenu, .mega-menu');

        dropdowns.forEach(dropdown => {
          dropdown.classList.remove('adjust-position', 'adjust-nested');

          const originalOpacity = dropdown.style.opacity;
          const originalVisibility = dropdown.style.visibility;

          dropdown.style.opacity = '1';
          dropdown.style.visibility = 'visible';

          const rect = dropdown.getBoundingClientRect();
          const viewportWidth = window.innerWidth;

          if (rect.right > viewportWidth - 10) {
            if (dropdown.closest('.submenu-item-wrapper')) {
              dropdown.classList.add('adjust-nested');
            } else {
              dropdown.classList.add('adjust-position');
            }
          }

          dropdown.style.opacity = originalOpacity;
          dropdown.style.visibility = originalVisibility;
        });
      };
      const menuItems = document.querySelectorAll('.header__menu-item.has-submenu');
      menuItems.forEach(item => {
        item.addEventListener('click', () => {
          setTimeout(adjustDropdownPosition, 20);
        });
      });
      window.addEventListener('resize', adjustDropdownPosition);
    }
    initHoverMenus() {
      this.cleanupMenus();

      var self = this;
      var mainMenuItems = this.querySelectorAll('.header__menu-item.has-submenu');

      // Clic fuera cierra todo
      this._docClickHandler = function(e) {
        if (!e.target.closest('.header__inline-menu')) {
          self.closeAllMenus();
        }
      };
      document.addEventListener('click', this._docClickHandler);

      mainMenuItems.forEach(function(menuItem) {
        menuItem.addEventListener('click', function(e) {
          // Si el clic viene de dentro del submenu, navegar normalmente
          if (e.target.closest('.header__submenu')) return;
          e.preventDefault();
          var wasOpen = menuItem.classList.contains('menu-open');
          mainMenuItems.forEach(function(other) {
            other.classList.remove('menu-open');
            other.querySelectorAll('.submenu-item-wrapper').forEach(function(n) {
              n.classList.remove('nested-open');
            });
          });
          if (!wasOpen) menuItem.classList.add('menu-open');
        });
      });

      var nestedItems = this.querySelectorAll('.submenu-item-wrapper');
      nestedItems.forEach(function(nestedItem) {
        var link = nestedItem.querySelector('a');
        if (!link) return;
        link.addEventListener('click', function(e) {
          var sub = nestedItem.querySelector('.header__submenu');
          if (!sub) return; // sin hijos: navegar normalmente
          e.preventDefault();
          e.stopPropagation();
          var wasOpen = nestedItem.classList.contains('nested-open');
          var parentSubmenu = nestedItem.closest('.header__submenu');
          if (parentSubmenu) {
            parentSubmenu.querySelectorAll('.submenu-item-wrapper').forEach(function(s) {
              s.classList.remove('nested-open');
            });
          }
          if (!wasOpen) nestedItem.classList.add('nested-open');
        });
      });
    }
    closeAllMenus() {
      const menuItems = this.header.querySelectorAll('.header__menu-item.has-submenu');
      menuItems.forEach(menuItem => {
        menuItem.classList.remove('menu-open');
      });

      const nestedItems = this.header.querySelectorAll('.submenu-item-wrapper');
      nestedItems.forEach(nestedItem => {
        nestedItem.classList.remove('nested-open');
      });
    }
    cleanupMenus() {
      this.closeAllMenus();
      if (this._docClickHandler) {
        document.removeEventListener('click', this._docClickHandler);
        this._docClickHandler = null;
      }
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // El observador que rellena headerBounds es asíncrono: si el usuario
      // hace scroll antes de que responda, headerBounds está vacío y todas
      // las comparaciones dan NaN, con lo que el header no se ocultaba nunca.
      // Por eso medimos aquí como respaldo.
      const bounds = this.headerBounds || {};
      const boundsTop = typeof bounds.top === 'number' ? bounds.top : 0;
      const boundsBottom =
        typeof bounds.bottom === 'number' && bounds.bottom > 0
          ? bounds.bottom
          : this.header.offsetHeight;

      // Arriba del todo: restablecer siempre, sin zona muerta.
      if (scrollTop <= boundsTop) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
        this.currentScrollTop = scrollTop;
        return;
      }

      // La sombra aparece en cuanto se pasa el header, sin esperar a la
      // decisión de ocultar/mostrar (si no, llegaba tarde).
      if (scrollTop > boundsBottom) {
        this.header.classList.add('scrolled-past-header');
      }

      // ── ZONA MUERTA ───────────────────────────────────────────────────
      // Evita que un micro-movimiento del scroll alterne entre ocultar y
      // mostrar. Al no actualizar currentScrollTop cuando ignoramos un
      // movimiento, los pequeños se van sumando hasta superar el umbral.
      const delta = scrollTop - this.currentScrollTop;
      if (Math.abs(delta) < 6) return;

      if (delta > 0 && scrollTop > boundsBottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (delta < 0 && scrollTop > boundsBottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      // TEKENO: el menú lo pinta Globo, así que algunos <header-menu> no tienen close().
      // Sin esta comprobación saltaba «disclosure.close is not a function» al ocultarse
      // el encabezado con el scroll (5% de las sesiones con error en Clarity).
      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') disclosure.close();
      });

      this.closeAllMenus();
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
